import { c as _c } from "react/compiler-runtime";
import { FormSelectDataType, getContactFieldTitle, Hint } from '@systemeio/ui';
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import { SubstituteInterface } from 'shared/components/dashboard-mail-editor/components/substitutes-block';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useSubstitutes = t0 => {
  const $ = _c(19);
  const additionalSubstitutes = t0 === undefined ? [] : t0;
  const {
    t
  } = useLocoTranslation();
  const {
    fields: substitutes
  } = useContactFields();
  const additionalSubstitutionData = additionalSubstitutes.map(_temp);
  const contactSubstitutionData = (substitutes?.items ?? []).map(_temp2);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.email.contact_affiliate_id");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      caption: t1,
      id: "{affiliate_id}"
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.email.contact_affiliate_url");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      a: <span className="block pl-3" />,
      b: <b />
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] !== t) {
    t5 = <TransLoco t={t} i18nKey="dashboard.email.clickable_url_description" components={t4} />;
    t6 = t("dashboard.email.contact_affiliate_url");
    $[7] = t;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Hint label={t5}>{t6}</Hint>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = {
      caption: t3,
      customCaption: t7,
      id: "{affiliate_dashboard}"
    };
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t8) {
    t9 = [t2, t8];
    $[16] = t2;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const affiliateSubstitutionData = t9;
  const substitutionData = [...additionalSubstitutionData, ...contactSubstitutionData, ...affiliateSubstitutionData];
  const isReady = !!substitutes;
  return {
    substitutionData,
    isReady
  };
};
function _temp(el) {
  return {
    id: `{${el.slug}}`,
    caption: el.name
  };
}
function _temp2(el_0) {
  return {
    id: `{${el_0.slug}}`,
    caption: getContactFieldTitle(el_0)
  };
}